import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Protected from "./Protected";
import Login from "../logIn";
import CardComponetSignup from "../Pages/auth/SignUp/cardcompSignup";
import NewPassword from "../Pages/auth/newpassword";
import "../assets/styles/Profile/Profile.css";
import NavbarHome from "../Pages/home/NavbarNew/NavbarHome";
import { LoadBoot } from "../components/LoadBoot";
import Home from "../Pages/home";
import ThankYouModel from "../components/Bussiness Steps/ThankYouModel";
import TermsOfService from "../components/TermsOfService";
import Admin from "../Admin/Admin";
import FirstStep from "../components/Presonal Steps/FirstStep";
import BussinessSteps from "../components/Bussiness Steps/BussinessSteps";
import PresonalSecondStep from "../components/Presonal Steps/PresonalSecondStep";
import PresonalThirdStep from "../components/Presonal Steps/PersonalThirdStep";
import FourthStep from "../components/Bussiness Steps/FourthStep";
import Dashboard from "../Pages/Dashboard/Dashboard";
import MyProfile from "../Pages/My-Profile/MyProfile";
import UserProfile from "../Pages/User_Profile/UserProfile";
import Profilesssss from "../Pages/User_Profile/Profilesssss";
import EventScreen from "../Pages/home/AddEventsPopup/EventScreen";
import Main from "../Pages/bussinessShare/Main";
import MainSettings from "../Pages/Settings/MainSettings";
import About from "../Pages/auth/footerLogin/About";
import Blog from "../Pages/auth/footerLogin/Blog";
import Contact from "../Pages/auth/footerLogin/Contact";
import Mission from "../Pages/auth/footerLogin/Mission";
import Press from "../Pages/auth/footerLogin/Press";
import PressRelease from "../Pages/auth/footerLogin/PressRelease";
import BlogLandingPage from "../Pages/auth/footerLogin/BlogLandingPage";
import PressRelese2 from "../Pages/auth/footerLogin/PressRelese2";
import Privacy from "../Pages/auth/footerLogin/Privacy";
import Terms from "../Pages/auth/footerLogin/Terms";
import Demo from "../Pages/Demo/Demo";
import { useSelector } from "react-redux";
import RedirectPage from "../utils/RedirectAffiliate";
import BusinessForm from "../components/Bussiness Steps/BusinessForm";
import MyProduct from "../Pages/Products/MyProduct";
import MyCart from "../Pages/Products/MyCart";
import CheckoutPage from "../Pages/Products/Checkout";
import PaymentSuccess from "../Pages/Products/PaymentSuccess";
import OrdersScreen from "../Pages/Products/Orders";
import ChildSafety from "../components/misc/ChildSafety";
const HighMap = lazy(() => import("../Pages/MapOverview/HighMap"));
const HighMap2 = lazy(() => import("../Pages/MapOverview/HighMap"));
const SettingRoutes = () => {
  const userData = useSelector((state) => state?.auth?.user?.user)
  return (
    <>
      <Routes>
        <Route path="/redirect/:name" element={<RedirectPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<CardComponetSignup />} />
        <Route path="/new_password" element={<NewPassword />} />

        {/* presonal Steps routes */}
        <Route
          path="/firstStep"
          element={<Protected Component={FirstStep} />}
        />
        <Route
          path="/secondStep"
          element={<Protected Component={PresonalSecondStep} />}
        />
        <Route
          path="/thirdStep"
          element={<Protected Component={PresonalThirdStep} />}
        />
        {/* Bussiness Steps routes */}
        <Route
          path="/businessStep"
          element={<Protected Component={BussinessSteps} />}
        />
        <Route path="/fourthStep" element={<FourthStep />} />
        <Route path="/thankyoumodel" element={<ThankYouModel />} />
        <Route path="/TermsOfService" element={<TermsOfService />} />

        <Route path="/artist-join" element={<BusinessForm />} />
        <Route path="/traveller-join" element={<BusinessForm />} />

        {/* Home */}
        <Route path="/" element={<Protected Component={Home} />} />

        {/* New Password */}
        {/* My Profile */}
        <Route
          path={`/${userData?.type?"business":"personal"}/:id/:name`}
          element={<Protected Component={MyProfile} />}
        />
        <Route path="/demo" element={<Demo />} />
        <Route path="/profile/:id/:name" element={<Profilesssss />} />
        <Route path="/profile/:id" element={<Profilesssss />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/BusinessProfile/:id/:name" element={<Main />} />
        <Route path="/BusinessProfile/:id" element={<Main />} />
        <Route
          path="/dashboard"
          element={<Protected Component={Dashboard} />}
        />
        <Route  path="/mapOverview" element={
          <Suspense fallback={
            <>
              <NavbarHome />
              <LoadBoot/>
            </>
          }>
            <Protected Component={HighMap} />
          </Suspense>
        } />
        
        {/* Events rouute */}
        <Route path="/Event" element={<EventScreen />} />
        {/* Setting rouute */}
        <Route
          path="/setting"
          element={<Protected Component={MainSettings} />}
        />
        {/* Login Footer */}
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/mission" element={<Mission />} />
        <Route path="/press" element={<Press />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/terms-of-service" element={<Terms />} />
        <Route path="/pressBlog" element={<PressRelease />} />
        <Route path="/blogLandingPage.html" element={<PressRelese2 />} />
        <Route path="/blogLanding" element={<BlogLandingPage />} />
        <Route path="/child-safety" element={<ChildSafety />} />


        {/* Procucts */}
        <Route path="/product/:id" element={<MyProduct />} />
        <Route path="/my-cart" element={<MyCart />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/my-orders" element={<OrdersScreen />} />

        {/* Admin routes */}
        <Route path="/admin" element={<Protected Component={Admin} />} />

        {/* Mobile Route used */}
        <Route
          path="/to"
          element={
            <Suspense fallback={<LoadBoot />}>
              <HighMap2 />
            </Suspense>
          }
        />
      </Routes>
    </>
  );
};

export default SettingRoutes;